var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "app-wrapper",
    {
      attrs: { sending: _vm.sending, title: _vm.title },
      on: {
        close: function ($event) {
          return _vm.close()
        },
      },
    },
    [
      _c(
        "w-card-content",
        { staticClass: "address", attrs: { "no-padding": "" } },
        [
          _vm.showMailSettingsSelect
            ? _c(
                "w-row",
                [
                  _c("w-col", { staticClass: "label", attrs: { sm: "2" } }, [
                    _vm._v(" " + _vm._s(_vm.$ct("select-mail-settings")) + " "),
                  ]),
                  _c(
                    "w-col",
                    { attrs: { sm: "10" } },
                    [
                      _c("w-select", {
                        attrs: {
                          items: _vm.mailSettingsItems,
                          value: _vm.usedMailSettings.ID,
                        },
                        on: {
                          input: function ($event) {
                            return _vm.setSelectedMailSettings($event)
                          },
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _c(
            "w-row",
            [
              _c("w-col", { staticClass: "label", attrs: { sm: "2" } }, [
                _vm._v(" " + _vm._s(_vm.$ct("to")) + " "),
              ]),
              _c(
                "w-col",
                {
                  style: { display: "flex", flexDirection: "row" },
                  attrs: { sm: "10" },
                },
                [
                  _c("w-input-autocomplete", {
                    ref: "toInput",
                    style: { width: "100%" },
                    attrs: { items: _vm.contactList },
                    on: {
                      "item-click": function ($event) {
                        return _vm.contactSelected($event)
                      },
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (p) {
                          return [
                            _vm._v(
                              " " +
                                _vm._s(
                                  p.item.name ? p.item.name : p.item.value
                                ) +
                                " " +
                                _vm._s(
                                  p.item.name ? "(" + p.item.value + ")" : ""
                                ) +
                                " "
                            ),
                          ]
                        },
                      },
                    ]),
                    model: {
                      value: _vm.mailData.to,
                      callback: function ($$v) {
                        _vm.$set(_vm.mailData, "to", $$v)
                      },
                      expression: "mailData.to",
                    },
                  }),
                  _c(
                    "w-button",
                    {
                      directives: [
                        {
                          name: "tooltip",
                          rawName: "v-tooltip",
                          value: _vm.extraAddressTooltipText,
                          expression: "extraAddressTooltipText",
                        },
                      ],
                      attrs: { flat: "" },
                      on: {
                        click: function ($event) {
                          return _vm.toggleExtraAddressFields()
                        },
                      },
                    },
                    [
                      _c("w-fa", {
                        staticClass: "toggle-address",
                        attrs: { icon: _vm.extraAddressIcon },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm.showExtraAddressFields || _vm.mailData.cc || _vm.additionalBcc
            ? _c(
                "w-row",
                [
                  _c("w-col", { staticClass: "label", attrs: { sm: "2" } }, [
                    _vm._v(" " + _vm._s(_vm.$ct("cc")) + " "),
                  ]),
                  _c(
                    "w-col",
                    { attrs: { sm: "10" } },
                    [
                      _c("app-select-bcc-input", {
                        attrs: { "suggested-addresses": _vm.contactBccList },
                        model: {
                          value: _vm.mailData.cc,
                          callback: function ($$v) {
                            _vm.$set(_vm.mailData, "cc", $$v)
                          },
                          expression: "mailData.cc",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm.showExtraAddressFields || _vm.mailData.bcc || _vm.additionalBcc
            ? _c(
                "w-row",
                [
                  _c("w-col", { staticClass: "label", attrs: { sm: "2" } }, [
                    _vm._v(" " + _vm._s(_vm.$ct("bcc")) + " "),
                  ]),
                  _c(
                    "w-col",
                    { attrs: { sm: "10" } },
                    [
                      _c("app-select-bcc-input", {
                        attrs: { "suggested-addresses": _vm.contactBccList },
                        model: {
                          value: _vm.mailData.bcc,
                          callback: function ($$v) {
                            _vm.$set(_vm.mailData, "bcc", $$v)
                          },
                          expression: "mailData.bcc",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm.showExtraAddressFields
            ? _c(
                "w-row",
                [
                  _c("w-col", { staticClass: "label", attrs: { sm: "2" } }, [
                    _vm._v(" " + _vm._s(_vm.$ct("from")) + " "),
                  ]),
                  _c(
                    "w-col",
                    { attrs: { sm: "10" } },
                    [
                      _c("w-input", {
                        ref: "mailFrom",
                        attrs: {
                          value: _vm.mailFromName,
                          autocapitalize: "none",
                          required: "",
                        },
                        on: {
                          blur: function ($event) {
                            _vm.editFrom = false
                          },
                          focus: function ($event) {
                            _vm.editFrom = true
                          },
                          input: function ($event) {
                            return _vm.updateFrom($event)
                          },
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _c(
            "w-row",
            [
              _c("w-col", { staticClass: "label", attrs: { sm: "2" } }, [
                _vm._v(" " + _vm._s(_vm.$ct("subject")) + " "),
              ]),
              _c(
                "w-col",
                { attrs: { sm: "10" } },
                [
                  _c("w-input", {
                    attrs: { required: "" },
                    on: {
                      input: function ($event) {
                        return _vm.$emit("update:subject", $event)
                      },
                    },
                    model: {
                      value: _vm.mailData.subject,
                      callback: function ($$v) {
                        _vm.$set(_vm.mailData, "subject", $$v)
                      },
                      expression: "mailData.subject",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._t("extras"),
        ],
        2
      ),
      _c(
        "w-card-content",
        { staticClass: "message", class: { editor: _vm.mailData.isHTML } },
        [
          !_vm.mailData.isHTML
            ? _c("textarea", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.mailData.body,
                    expression: "mailData.body",
                  },
                ],
                attrs: { rows: "10" },
                domProps: { value: _vm.mailData.body },
                on: {
                  input: [
                    function ($event) {
                      if ($event.target.composing) return
                      _vm.$set(_vm.mailData, "body", $event.target.value)
                    },
                    function ($event) {
                      return _vm.$emit("update:content", $event)
                    },
                  ],
                },
              })
            : _c("vue-editor", {
                staticClass: "html-editor",
                attrs: { "use-custom-image-handler": "" },
                on: { "image-added": _vm.handlerImageAdded },
                model: {
                  value: _vm.mailData.body,
                  callback: function ($$v) {
                    _vm.$set(_vm.mailData, "body", $$v)
                  },
                  expression: "mailData.body",
                },
              }),
        ],
        1
      ),
      _c(
        "w-card-content",
        { staticClass: "attach" },
        _vm._l(_vm.mailData.attachments, function (attachement, i) {
          return _c(
            "span",
            { key: i },
            [
              _c(
                "w-link",
                {
                  on: {
                    click: function ($event) {
                      return _vm.downloadAttachment(attachement)
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.getAttachmentName(attachement)))]
              ),
              _c(
                "w-button",
                {
                  style: { margin: "0 0 0 0" },
                  attrs: { flat: "" },
                  on: {
                    click: function ($event) {
                      return _vm.removeAttachement(i)
                    },
                  },
                },
                [_c("w-fa", { attrs: { icon: "times" } })],
                1
              ),
            ],
            1
          )
        }),
        0
      ),
      _c(
        "w-card-actions",
        [
          _vm._t("left-actions"),
          _c("w-spacer"),
          _vm._t("extra-actions"),
          _vm._t("templates"),
          _c(
            "app-file-input",
            {
              directives: [
                {
                  name: "tooltip",
                  rawName: "v-tooltip",
                  value: _vm.$ct("tooltip.add-attachment"),
                  expression: "$ct('tooltip.add-attachment')",
                },
              ],
              style: { display: "inline-flex", flexDirection: "column" },
              attrs: { multiple: true },
              on: {
                input: function ($event) {
                  return _vm.onFileAdded($event)
                },
              },
            },
            [
              _c(
                "w-button",
                { style: { flexGrow: 1 }, attrs: { flat: "" } },
                [_c("w-fa", { attrs: { icon: "paperclip" } })],
                1
              ),
            ],
            1
          ),
          _c(
            "w-button",
            {
              attrs: {
                disabled: _vm.disabled || _vm.sending,
                icon: "paper-plane",
              },
              on: {
                click: function ($event) {
                  return _vm.send()
                },
              },
            },
            [_vm._v(" " + _vm._s(_vm.$t("common.send")) + " ")]
          ),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }